const log = (message:any) => {
    console.log('Sending to Elastic Search: ', message);
}

export default log;